module.exports = __webpack_public_path__ + "img/sunset-banner.58c20450.png";